import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './CheckIcon.module.scss';

const CheckIcon: FC<CheckIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.checkIcon, className]}
      viewBox="0 0 512 512"
      {...rest}
    >
      <path className={styles.cls1} d="M416 128L192 384l-96-96" />
    </Svg>
  );
};

type CheckIconProps = {
  className?: string;
};

export default CheckIcon;
